import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=5d02f62a&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"
import style0 from "./shop.vue?vue&type=style&index=0&id=5d02f62a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d02f62a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d02f62a')) {
      api.createRecord('5d02f62a', component.options)
    } else {
      api.reload('5d02f62a', component.options)
    }
    module.hot.accept("./shop.vue?vue&type=template&id=5d02f62a&scoped=true", function () {
      api.rerender('5d02f62a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/shop.vue"
export default component.exports